<template>
  <div>
      <b-row class="mx-25 align-items-center">
        <b-col cols="8">
          <h3 class="mr-50">
            <feather-icon size="20" icon="FileIcon" />
            طلبات المعاملات
          </h3>
        </b-col>
  
        <b-col cols="4" v-if="!canAddTransaction">
          <validation-observer ref="typeOfTransaction">
            <b-form @submit.prevent="onChooseTypeOfTransaction()">
              <b-row>
                <b-col cols="10">
                  <form-select
                    placeholder="نوع المعاملة"
                    :options="TransactionType"
                    :reduce="(el) => el.slug"
                    :getOptionLabel="(x) => x.name"
                    v-model="type_of_transaction"
                    rules="required"
                    :working="loadingTransactionType"
                  > 
                 
                </form-select>
                </b-col>
                <b-col cols="2">
                  <b-button
                    type="submit"
                    variant="success"
                    v-can="{ slug: $route.meta.slug, action: 'C' }"
                    class="btn-icon"
                    :disabled="loadingcheckConsecutiveSubmission"
                  >
                    <feather-icon class="mx-25" icon="PlusIcon" />
                  </b-button>
  
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
        
      </b-row>
      <hr />
      <alert
        massage="لا يمكنك تقديم المعاملات قبل أن تتم الموافقة على اعتماد الملف الشخصي"
        class="w-100 mx-1"
        v-if="canAddTransaction"
      ></alert>
      <div v-else>
      
        <b-row class="mx-25" v-if="transactionDescription" >
          <b-col cols="12" class="mr-50">
            <transition name="VExpandTransition">
              <div>
                <h4>
                  نص توضيحي حول {{transactionInfo.name}}
                </h4>
                <div class="mt-2">
    
                  <b-skeleton v-if="loadingFetchTransactionDesc" width="100%" height="150px"></b-skeleton>
                  <div v-else>
    
                    <p v-html="TransactionDesc[0].description" ></p>
                  </div>
                </div>
              </div>
            </transition>
          </b-col>
        </b-row>
        <hr  v-if="transactionDescription" />
    
        <b-row>
          <b-col cols="12">
            <transaction-filters  class="mt-1" @filterChanged="onFilterChanged" />
          </b-col>
        </b-row>
    
    
        <hr />
    
        <b-row>
          <b-col cols="12">
            <data-table
              ref="transactionsTable"
              ep="v2/transaction-requests"
              :fields="fields"
            >
              <template #cell(status)="{ value }">
                <transactions-status-formatter :value="value" />
              </template>
              <template #cell(created_at)="{ value }">
                {{ formatDate(value, "YYYY-MM-DD") }}
              </template>
              
              <template #cell(updated_at)="{ value }">
                {{ formatDate(value, "YYYY-MM-DD") }}
              </template>
              
              <template #cell(actions)="{ item: { id, transactionType } }">
                <b-dropdown
                  variant="link"
                  no-caret
                  :left="$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    v-can="{ slug: $route.meta.slug, action: 'S' }"
                    target="_blank"
                    @click="$router.push({ name: 'transactions-show', params: { id } })"
                  >
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50">عرض المعاملة</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="activeFilter === 'need_review'"
                    v-can="{ slug: $route.meta.slug, action: 'S' }"
                    @click="editTransiction(id , transactionType)"
                  >
                    <feather-icon icon="ListIcon" />
                    <span class="align-middle ml-50"> استدراك المعاملة</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </data-table>
          </b-col>
        </b-row>
      
      </div>
      <component 
        :is="getCurrentModal"
        :loading="loading"
        :mainTitle="`${type_of_action} بيانات ${transactionInfo.name}`"
        @confirm="onConfirm"
        v-model="currentModalData"
        :initializeForm="form"
        ref="currentModalRef"
      />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BRow, BButton, BCol, BCard , BModal , BImg , BFormGroup , BForm , BCardText , BSpinner , BSkeleton ,BDropdown , BDropdownItem} from "bootstrap-vue";
import DataTable from "@/components/data-table";
import { mapActions, mapGetters } from "vuex";
import formInput from "@/components/form-input";
import FormModal from "@/components/FormModal.vue";
import AppTimelineItem from "@/@core/components/app-timeline/AppTimelineItem.vue";
import formSelect from "@/components/form-select";
// import BranchModal from "@/modules/ngo/ngo-profile/components/BranchModal.vue";
import EditActivityModal  from "@/modules/ngo/annual-plan/components/EditActivityModal.vue";
import Alert from "@/components/Alert.vue";
import { getTransactionRequest , getModifiedTransactionDataToSend , getModifiedTransactionData } from "./utils";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { formatDate } from "@/utils/utils";
import {
  ActivityModal,
  CampaignModal,
  MeetingsModal,
  MemberModal,
  BoardModal,
  CollaborationModal,
  FinancialGrantModal,
  TransactionFilters,
  HoldGeneralBodyMeeting,
  LogoModal ,
  ExternalDonationModal,
  DissolutionNGOModal,
  moneyTransferModal,
  internalDonationModal,
  TransactionsStatusFormatter,
  ActivityFormModal,
  InternationalEventsSubscription,
  UnknownBranchModal,
  JoiningInternationalNGOModal,
  BranchModal,
  ComplaintAndObjectionAgainstViolation,
  ModifyingInternalSystem,
  MergingTwoNgos
} from "../../components";
export default {
  components: {
    ActivityFormModal,
    DataTable,
    BRow,BButton,
    BCol,
    BCard,
    BModal,
    BImg,
    BFormGroup,
    BSpinner,
    BCardText,
    BForm,
    BSkeleton,
    BDropdown,
    BDropdownItem,
    FormModal, 
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    formSelect,
    formInput,
    BranchModal,
    ActivityModal, 
    CampaignModal,
    MeetingsModal, 
    MemberModal, 
    CollaborationModal , 
    FinancialGrantModal, 
    HoldGeneralBodyMeeting, 
    TransactionsStatusFormatter,
    TransactionFilters, 
    BoardModal,
    EditActivityModal,
    ExternalDonationModal,
    internalDonationModal, 
    moneyTransferModal, 
    InternationalEventsSubscription,
    DissolutionNGOModal,
    LogoModal,
    UnknownBranchModal ,
    JoiningInternationalNGOModal,
    ComplaintAndObjectionAgainstViolation,
    ModifyingInternalSystem,
    MergingTwoNgos ,
    Alert ,
    
    ToastificationContent,
  },
  data() {
    return {
      currentModalData : false ,
      oldData : {},
      idEdit : null ,
      editRequest : false ,
      activeFilter : 'all' ,
      typeRequest :false ,
      dataRequest : false ,
      showRequest : false , 
      type_of_transaction :'' ,
      type_of_action :'' ,
      working : false ,
      transactionDescription : false ,
      transactionInfo:{},
      title :"بيانات معاملة",
      form : {},
      dataRequestSchema :{},
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "transactionType.name",
          label: "نوع المعاملة",
        },
        {
          key: "status",
          label: "حالة المعاملة",
        },
        
        { label: "الحد الأقصى لإنجاز المعاملة", key: "transactionType.total_duration" },
        {
          key: "created_at",
          label: "تاريخ تقديم المعاملة",
        },
        {
          key: "updated_at",
          label: "تاريخ أخر تعديل على المعاملة",
        },
        { key: "actions", label: " " },
      ],
    };
  },
  computed: {
    ...mapGetters("Transactions/Transactions", ["Transaction"  , "loading" , "OrgInformation" , "TransactionType" , "loadingFetchTransactionDesc" , "TransactionDesc" , "loadingTransactionType" , "ifCanConsecutiveSubmission" , "loadingcheckConsecutiveSubmission"]),
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
    getCurrentModal() {
      switch (this.type_of_transaction) {
        case 'logo_approval':
          return 'logo-modal';
        case 'minutes_of_administrative_meetings':
          return 'meetings-modal';
        case 'member_of_board_of_directors_or_Trustees':
          return 'member-modal';
        case 'fundraising_campaign':
          return 'campaign-modal';
        case 'open_office':
          return 'branch-modal';
        case 'annual_plan_approval':
          return 'activity-modal';
        case 'collaboration_two_local_partners':
          return 'collaboration-modal';
        case 'financial_grant_request':
          return 'financial-grant-modal';
        case 'hold_general_body_meeting':
          return 'hold-general-body-meeting';
        case 'hold_general_body_meeting_2':
          return 'hold-general-body-meeting';
        case 'changing_the_board_of_directors_or_trustees':
          return 'board-modal';
        case 'national_donations':
          return 'internal-donation-modal';
        case 'transfer_money_abroads': 
          return 'money-transfer-modal'
        case 'dissolution_of_an_NGO': 
          return 'dissolution-NGO-Modal'
        case 'international_donations': 
          return 'external-donation-modal'
        case 'international_events_subscriptions':
          return 'international-events-subscription'
        case 'membership_application_to_international_organization':
          return 'joining-international-nGO-modal'
        case 'un_known_branch':
          return 'unknown-branch-modal'
        case 'complaint_and_objection_against_violation':
          return 'complaint-and-objection-against-violation'
        case 'internal_system_modification_requests':
          return 'modifying-internal-system'
        case 'merging_two_ngos':
          return 'merging-two-ngos'
        default:
          return '';
      }
    },
  },
  
  created() {
   let userData = JSON.parse(localStorage.getItem("user")) 
   this.form.ngo_id = userData.ngo.id
  
  },
  mounted(){
    this.activeFilter = 'all'
    this.fetchTransactionType()
  },
  methods: {
    ...mapActions("Transactions/Transactions", ["createTransactions" , "fetchTransactioById" , "updateTransactions" , "fetchOrgInformation" , "fetchTransactionType" , "fetchTransactionDesc"  , "checkConsecutiveSubmission"]),
   restVarOnAdd(){
      this.type_of_transaction = "";
      this.type_of_action ="";
      this.form = {};
      this.currentModalData = false
   },
   formatDate(value , formFormat) {
      return formatDate(value, formFormat);
    },
   restVarOnEdit(){
    this.form = {}
    this.type_of_transaction = ""
    this.type_of_action =""
    this.transactionDescription = false 
    this.currentModalData = false

   },
    onFilterChanged(filter) {
      this.activeFilter = filter;
    },
    async onChooseTypeOfTransaction(){
      this.form ={}
      
      await this.$refs.typeOfTransaction.validate().then(async (success) => {
        if (success) {
          
          await this.checkConsecutiveSubmission(this.transactionInfo.id)
          if(this.ifCanConsecutiveSubmission){
            this.type_of_action = 'إضافة'
            this.currentModalData = true 
          }else{
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "هناك معاملة مقدمة مسبقاً من نفس هذا النوع و لم يتم إغلاقُها بعد ، لذلك لا تستطيع تقديم معاملة جديدة",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
            this.type_of_transaction = ""
          }
        }

      });
      if(this.currentModalData === true ){
        if(this.type_of_transaction === "annual_plan_approval"){
          this.form.status = 'planning'
          this.form.data = [{}];
        }
        if(this.type_of_transaction ==="complaint_and_objection_against_violation"){
          this.form.files = [{name:"كتاب خطي يوضح العقوبة أو الإجراء المفروض بحقها"}];
        }
        if (this.type_of_transaction === "changing_the_board_of_directors_or_trustees"){
          this.working = true
          this.title = "بيانات معاملة تغيير مجلس إدارة"
          await this.fetchOrgInformation().then(()=>{
            console.log("OrgInformation" , this.OrgInformation.data.board_members_count)
            this.form.term_of_office = this.OrgInformation.data.term_of_office
            this.form.directors = []
            for(let i=0 ; i< this.OrgInformation.data.board_members_count ; i++){
              this.form.directors.push({})
            }
          }).catch(()=>{
          })
          this.working = false
        }
        this.$refs.currentModalRef.init(this.form)
      }

    },
    async editTransiction(id , type){
      this.form ={}
      this.type_of_action = 'استدراك'
      await this.fetchTransactioById(id).then(()=> {
          this.idEdit = id 
          this.type_of_transaction = type.slug
          this.oldData = this.Transaction.transactionRequestData
          this.currentModalData = true
      });
      if(this.currentModalData === true){
        this.form = getModifiedTransactionData( this.type_of_transaction  , this.Transaction)
        this.$refs.currentModalRef.init(this.form)
      }
    },
    onConfirm(form){
      if(this.type_of_action === 'إضافة'){
        this.onConfirmAddRequest(form)
      }
      else{
        this.onConfirmEditRequest(form)
      }
    },
    async onConfirmAddRequest(form){
      const req = getTransactionRequest(form , this.type_of_transaction )
      if(req){
        this.createTransactions(req).then(() => {
          this.$refs.transactionsTable.refreshTable();
          this.restVarOnAdd()
        })
        .catch((err) => {
          console.log(err)
        });
      }

    },
    async onConfirmEditRequest(form){
      const req = getModifiedTransactionDataToSend(this.oldData , form , this.type_of_transaction  )
      let id = this.idEdit
      this.updateTransactions({ id ,req}).then(() => {
       
        this.$refs.transactionsTable.refreshTable();
        this.restVarOnEdit()
      })
      .catch((err) => {
        console.log(err)
      });
  },
  },
  watch:{
    activeFilter(val) {
      this.$refs.transactionsTable.setQueryParams({ tab: val });
      this.$refs.transactionsTable.refreshTable();
    },
    type_of_transaction(val){
      this.activeFilter = 'all'
      this.form = {}
      if(val){
        this.transactionDescription = true ;
        this.transactionInfo = this.TransactionType.find(obj => obj.slug === this.type_of_transaction);
        this.fetchTransactionDesc(this.transactionInfo.id)
      }
      else{
        this.transactionDescription = false ;
        this.transactionInfo = [];
      }
    },
  }
};
</script>
<style>
li.timeline-item
{
  list-style: none;
}
</style>
